<tui-push
  *tuiPush="true"
  type="Есть обновление"
  [lines]="8"
  (close)="toggle(false)"
>
  <tui-icon icon="@tui.rocket"/>
  Доступна новая версия с исправлениями. Обновиться сейчас или позже?
  <button
    style="font-size: 14px"
    tuiButton
    type="button"
    appearance="accent"
    size="m"
    (click)="toggle(true)"
  >
    Обновить
  </button>
  <button
    style="font-size: 14px"
    tuiLink
    type="button"
    size="m"
    (click)="toggle(false)"
  >
    Попозже
  </button>
</tui-push>
